import { Injectable } from '@angular/core';
import { HttpService } from './http.service';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {AuthService} from './auth.service';
import { Observable, Subject } from 'rxjs';

@Injectable()
export class AuthServiceAuthenticatedUsersService implements CanActivate {

  authenticated;
  constructor(private http: HttpService, private router: Router, private auth: AuthService) { }

   canActivate(route: ActivatedRouteSnapshot,
              state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean{
       var subject = new Subject<boolean>();
       let isHome;
      //  this.http.isAuthenticated().subscribe((res: any)=>{
      //     if(!res.authenticated){
      //       //console.log(res.authenticated);
      //       subject.next(true);
      //       subject.complete();
      //     }else{
      //       subject.next(false);
      //       this.router.navigate(['/feed']);
      //     }
         
      //  })

      if(localStorage.getItem('token')){
        console.log('rrrrrrrrrrrrrrrrrrrrr---------------rrrr')
        if(this.http.isLocalAuthenticated()){
          this.router.navigate(['/feed']);
        }else{
          this.auth.retrieveToken();
          isHome = false;
          this.router.navigate(['/feed']);
        }
      }else{
        console.log('dddddd-------------------------dddddddddddd')
        isHome = true;
      }

       return isHome;         
  }


}
